/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AsatPowerMeterResultDto
 */
export interface AsatPowerMeterResultDto {
    /**
     * Power meter UniqueId (from CoreConfig).
     * @type {string}
     * @memberof AsatPowerMeterResultDto
     */
    powerMeterUniqueId?: string;
    /**
     * 1-based electrical phase (1, 2 or 3) this result applies to.
     * @type {number}
     * @memberof AsatPowerMeterResultDto
     */
    phase?: number;
    /**
     * Power meter phase status.
     * @type {string}
     * @memberof AsatPowerMeterResultDto
     */
    status?: AsatPowerMeterResultDtoStatusEnum;
    /**
     * Failure code when status is Failed; otherwise null.
     * @type {string}
     * @memberof AsatPowerMeterResultDto
     */
    failureCode?: AsatPowerMeterResultDtoFailureCodeEnum;
    /**
     * Human-readable detail about the result; null when cleared on reset.
     * @type {string}
     * @memberof AsatPowerMeterResultDto
     */
    detail?: string;
}

/**
 * @export
 */
export const AsatPowerMeterResultDtoStatusEnum = {
    Unknown: "Unknown",
    Pending: "Pending",
    InProgress: "InProgress",
    Passed: "Passed",
    Failed: "Failed",
    Inconclusive: "Inconclusive",
} as const;
export type AsatPowerMeterResultDtoStatusEnum =
    (typeof AsatPowerMeterResultDtoStatusEnum)[keyof typeof AsatPowerMeterResultDtoStatusEnum];

/**
 * @export
 */
export const AsatPowerMeterResultDtoFailureCodeEnum = {
    Unknown: "Unknown",
    VoltageOutOfRange: "VoltageOutOfRange",
    PowerFactorOutOfRange: "PowerFactorOutOfRange",
    CurrentTransformerBackwards: "CurrentTransformerBackwards",
} as const;
export type AsatPowerMeterResultDtoFailureCodeEnum =
    (typeof AsatPowerMeterResultDtoFailureCodeEnum)[keyof typeof AsatPowerMeterResultDtoFailureCodeEnum];

/**
 * Check if a given object implements the AsatPowerMeterResultDto interface.
 */
export function instanceOfAsatPowerMeterResultDto(
    value: object,
): value is AsatPowerMeterResultDto {
    return true;
}

export function AsatPowerMeterResultDtoFromJSON(
    json: any,
): AsatPowerMeterResultDto {
    return AsatPowerMeterResultDtoFromJSONTyped(json, false);
}

export function AsatPowerMeterResultDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AsatPowerMeterResultDto {
    if (json == null) {
        return json;
    }
    return {
        powerMeterUniqueId:
            json["powerMeterUniqueId"] == null
                ? undefined
                : json["powerMeterUniqueId"],
        phase: json["phase"] == null ? undefined : json["phase"],
        status: json["status"] == null ? undefined : json["status"],
        failureCode:
            json["failureCode"] == null ? undefined : json["failureCode"],
        detail: json["detail"] == null ? undefined : json["detail"],
    };
}

export function AsatPowerMeterResultDtoToJSON(
    value?: AsatPowerMeterResultDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        powerMeterUniqueId: value["powerMeterUniqueId"],
        phase: value["phase"],
        status: value["status"],
        failureCode: value["failureCode"],
        detail: value["detail"],
    };
}
